<template>
  <div>
    <div class="container">

      <div class="row">
        <div class="col-sm-7 col-md-offset-1 col-md-6 col-lg-offset-3 col-lg-4">

          <div class="form-group has-feedback form-group-ville">
            <div class="input-group">
              <span class="input-group-addon"><i class="icon-pictos_site_OIP_pointeur"></i></span>
              <input type="text" list="city" v-model="address" class="form-control input-lg" placeholder="Rechercher par ville" @keyup="locateAddress">
              <span v-if="this.address" @click.prevent='clearAddress' class="form-control-feedback" aria-hidden="true"><i class="icon-pictos_site_OIP_fermer"></i></span>
              <datalist id="city">
                <option :value="cityProposition.toLowerCase()">{{ cityProposition }}</option>
              </datalist>
            </div>
          </div>

          <p class="ou">ou</p>

          <div class="form-group has-feedback form-group-disp">
            <div class="input-group">
              <span class="input-group-addon"><i class="icon-pictos_site_OIP_DISP"></i></span>
              <input list="disp" v-model="disp" type="text" class="form-control input-lg" placeholder="Rechercher par DISP*">
              <span v-if="this.disp" @click.prevent='clearDisp' class="form-control-feedback" aria-hidden="true"><i class="icon-pictos_site_OIP_fermer"></i></span>
              <datalist id="disp">
                <option v-for="disp in disps" :value="disp.value">{{ disp.label }}</option>
              </datalist>
              <div class="disp-field-helper"><sup>*</sup>Direction Interrégionale des Services Pénitentiaires</div>
            </div>
          </div>

        </div>

        <div class="col-sm-5 col-md-5 col-lg-5 oip-checkbox-container">

          <div v-for="nature in natures" class="oip-checkbox">
            <input type="checkbox" :value="nature.value" :id="nature.value" v-model="nature.checked">
            <label class="oip-checkbox-label">{{ nature.label }}</label>
          </div>

          <button v-if="$root.map" @click="search" class="btn btn-primary">Rechercher</button>

        </div>

      </div>

    </div>
    <br>

    <div id="map"></div>
    <div class="container etablissements-result">

      <div class="row">
        <div class="col-md-12">
          <h2 class="two-blocks-block-title"><i class="icon-pictos_site_OIP_logo"></i> Liste des établissements</h2>
        </div>
      </div>

      <etablissements-list :etablissements="etablissements"></etablissements-list>

      <p class="no-result" v-if="etablissements.length == 0">
        Aucun établissement trouvé pour vos critères de recherche.
      </p>

    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import EtablissementsList from './EtablissementsList.vue'

  export default {
    components: {
      EtablissementsList
    },

    data () {
      return {
        etablissements: [],
        disps: [],
        address: '',
        cityProposition: '',
        disp: '',
        dispProposition: '',
        natures: [],
        googleMapMarkers: [],
        markerCluster: []
      }
    },

    computed: {

      bounds () {
        return this.$root.map ? new google.maps.LatLngBounds() : null
      },

    },

    methods: {

      locateAddress () {
        if (this.address) {
          let geocoder = new google.maps.Geocoder()
          geocoder.geocode({ address: this.address + ', France' }, (results, status) => {
            if (status === google.maps.GeocoderStatus.OK) {
              _.forEach(results[0].address_components, (address_component) => {
                if (address_component.types[0] == "locality") {
                  this.cityProposition = address_component.long_name
                }
              })
            }
          })
        }
      },

      getInitialState () {
        this.etablissements = JSON.parse(window.initialState.etablissements)
        this.disps = JSON.parse(window.initialState.disps)
        _.forEach(JSON.parse(window.initialState.natures_de_letablissement), item => {
          this.natures.push({
            label: item.label,
            value: item.value,
            checked: true
          })
        })

        document.getElementById('app-container').classList.remove('loading')
      },

      addMarkers () {
        _.forEach(this.etablissements, etablissement => {
          let infoContent = `<div class="map_info">
            <h3 class="in-map-title"><i class="icon-pictos_site_OIP_logo"></i> ${etablissement.title}</h3>
            <p>
              <a class="btn btn-xs btn-primary" href="/sinformer/etablissements/${etablissement.slug}">Voir l'établissement</a>
            </p>
          </div>`

          let infoWindow = new google.maps.InfoWindow({ content: infoContent })

          let position = new google.maps.LatLng(
              etablissement.localisation.lat,
              etablissement.localisation.lng
          )

          this.bounds.extend(position)

          etablissement.marker = new google.maps.Marker({
            position: position,
            icon: {
              url: window.gmapMarker,
              scaledSize: new google.maps.Size(28, 40),
              origin: new google.maps.Point(0, 0)
            },
            map: this.$root.map
          })

          etablissement.marker.addListener('click', () => {
            infoWindow.open(this.$root.map, etablissement.marker)
          })

          this.centerMap()
        })
      },

      updateMarkerCluster () {
        this.clearMarkerCluster()
        this.googleMapMarkers = _.map(this.etablissements, 'marker')
        this.markerCluster = new MarkerClusterer(this.$root.map, this.googleMapMarkers, {
          styles: [{
            textColor: '#ffffff',
            url: window.gmapClusterMarker + '1.png',
            height: 33,
            width: 33,
            textSize: 18
          }, {
            textColor: '#ffffff',
            url: window.gmapClusterMarker + '1.png',
            height: 33,
            width: 33,
            textSize: 18
          }, {
            textColor: '#ffffff',
            url: window.gmapClusterMarker + '1.png',
            height: 33,
            width: 33,
            textSize: 18
          }]
        })
      },

      centerMap () {
        this.$root.map.fitBounds(this.bounds)
      },

      clearMarkers () {
        this.markerCluster.clearMarkers()
        _.forEach(this.etablissements, etablissement => {
          etablissement.marker.setMap(null)
        })
      },

      clearMarkerCluster () {
        this.googleMapMarkers = []
        this.markerCluster = []
        if (this.markerCluster instanceof MarkerClusterer) {
          this.markerCluster.clearMarkers()
        }
      },

      parseNatures () {
        let natures = []
        _.forEach(this.natures, nature => {
          if (nature.checked) {
            natures.push(nature.value)
          }
        })

        if (natures.length == 0) {
          return 'zero_result'
        }

        return _.join(natures, ',')
      },

      search () {
        let url = apiUrl + 'oip/v1/etablissements'
            + '?ville=' + this.address
            + '&disp=' + this.disp
            + '&nature_de_letablissement=' + this.parseNatures()

        this.$http.get(url).then(response => {

          this.clearMarkers()
          this.etablissements = response.body
          this.addMarkers()
          this.updateMarkerCluster()
          this.scrollToMap()
        }).catch(response => console.log(response))
      },

      scrollToMap () {
        document.getElementById('map')
          .scrollIntoView({ behavior: 'smooth' })
      },

      clearDisp () {
        this.disp = ''
      },

      clearAddress () {
        this.address = ''
      }

    },

    watch: {

      bounds () {
        if (this.bounds) {
          this.addMarkers()
          this.updateMarkerCluster()
        }
      },

      markers () {
        if (this.bounds) {
          this.addMarkers()
        }
      },

      address () {
        if (this.address) {
          this.disp = ''
        }
      },

      disp () {
        if (this.disp) {
          this.address = ''
        }
      }

    },

    mounted () {
      this.getInitialState()
    }
  }
</script>

<style>
  #map {
    width: 100%;
    height: 590px;
  }

  .map_info .title {
    font-size: 15px;
  }

  .form-control-feedback {
    z-index: 999 !important;
    pointer-events: auto !important;
  }

  .form-control-feedback:hover {
    cursor: pointer;
  }

  .in-map-title {
    border-bottom: 3px solid #000;
    padding-bottom: 5px;
    margin-bottom: 20px;
  }

  .in-map-title i {
    color: #f33e31;
  }

  .map_info .btn-xs {
    padding-left: 15px;
    padding-right: 15px;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/etablissements/EtablissementPage.vue